/**
 * Created by john on 7/16/15.
 */

'use strict';

const BaseStore  = require('fluxible/addons/BaseStore');
const NavActions = require('../actions/ActionConstants').NAV;

/**
 * Stores the list of components that are displayed in the nav bar.
 */
class NavBarItemStore extends BaseStore {

    constructor(dispatcher) {
        super(dispatcher);

        this.currentGroup    = 'default';
        this.componentGroups = {
            'default': []
        };
        this.components      = [];
    }

    getState() {
        return {
            components: this.getItems()
        };
    }

    getItems(group) {
        const groupKey = group || this.currentGroup || 'default';
        return this.componentGroups[groupKey];
    }

    /**
     * Changes the list of components that is currently rendered.
     * @param payload
     * @param payload.group
     */
    onActiveGroupChanged(payload) {
        this.currentGroup = payload.group;
        this.emitChange();
    }

    /**
     * Adds a component to the list.
     * @param payload
     * @param payload.group      {string}    A key representing the list to add these components to.
     * @param payload.components {Array}     An array of react components representing items to be shown in the nav bar.
     * @param payload.index      {number}    The location in which the components should be inserted into the nav bar.
     */
    onComponentsAdded(payload) {
        const {components, index} = payload;
        const groupKey = payload.group || 'default';
        var componentGroup;
        if (components && components.length) {
            componentGroup = this.componentGroups[groupKey];
            if (!componentGroup) {
                componentGroup = this.componentGroups[groupKey] = [];
            }
            Array.prototype.splice.apply(componentGroup, [index, 0].concat(components));
            this.emitChange();
        }
    }

    /**
     * Removes a component from the list.
     * @param payload
     * @param payload.key   {Component} A react component to remove from the nav bar.
     * @param payload.group {string}    The group to remove the component from. 'default' if not provided.
     */
    onComponentsRemoved(payload) {
        const {component, group} = payload;
        let componentGroup = this.componentGroups[group || 'default'];
        if (componentGroup && component) {
            // TODO: actually remove the component
            this.emitChange();
        }
    }

    /**
     *
     * @param payload
     */
    onNavigate(payload) {
        console.log(payload);
        this.emitChange();
    }

}

NavBarItemStore.storeName = 'NavBarItemStore';

NavBarItemStore.handlers = {
    [NavActions.NAVIGATED]           : 'onNavigate',
    [NavActions.ITEMS_ADDED]         : 'onComponentsAdded',
    [NavActions.ITEMS_REMOVED]       : 'onComponentsRemoved',
    [NavActions.ACTIVE_GROUP_CHANGED]: 'onActiveGroupChanged'
};

module.exports = NavBarItemStore;



// WEBPACK FOOTER //
// ./assets/js/global/core/nav/stores/NavBarItemStore.es.js